module.exports = __webpack_public_path__ + "media/images/circle-scatter-ca4d7268b7a9f18e6f81090f24ded3ad.svg";